import Link from 'next/link';
import { PAGES } from '@/constants/pages';
import Logo from '@/components/Logo';
import SearchButton from './SearchButton';
import Notifications from './Notifications';
import UserMenu from './UserMenu';
import { classes, styles } from './utils';

export { HEADER_HEIGHT } from './constants';

export default function AppHeader() {
  return (
    <header className={classes.header} style={styles.header}>
      <Link href={PAGES.HOME} className={classes.logoLink}>
        <Logo className={classes.logo} />
      </Link>
      <div className={classes.actions}>
        <SearchButton />
        <Notifications />
        <UserMenu />
      </div>
    </header>
  );
}
